// Per-page tour scripts. Each tour is keyed by a stable identifier; the
// localStorage seen-flag is namespaced by that key. Bump the suffix
// (e.g. "overview-v1" → "overview-v2") to re-run a tour for everyone
// after meaningful changes.
//
// Selectors target stable data-tour attributes added in the page JSX so
// the tour doesn't break when Tremor's internal class names shift.

import type { TourStep } from '../components/Tour';

export const TOURS: Record<string, { key: string; steps: TourStep[] }> = {
  overview: {
    key: 'overview-v1',
    steps: [
      {
        title: 'Bienvenido al tablero',
        body: 'Esta es tu vista general. Verás ventas, cuentas por cobrar e inventario al momento del último corte de datos.',
      },
      {
        selector: '[data-tour="kpi-row"]',
        title: 'Indicadores principales',
        body: 'Las tarjetas son enlaces — haz clic para ir al detalle. La barra de antigüedad bajo "Cuentas" muestra el riesgo de cobranza a simple vista.',
      },
      {
        selector: '[data-tour="sales-period-chart"]',
        title: 'Ventas con comparación',
        body: 'Cambia entre Día / Semana / Mes / Año. Los dos colores comparan el periodo actual contra el mismo periodo anterior (apples-to-apples a la fecha).',
      },
      {
        selector: '[data-tour="store-filter"]',
        title: 'Filtro de tienda',
        body: 'Si tienes varias tiendas, filtra las listas operacionales. Los indicadores arriba se mantienen a nivel cadena.',
      },
      {
        selector: '[data-tour="refresh-btn"]',
        title: 'Actualizar',
        body: 'Vuelve a leer los datos del último corte sin recargar la página. El botón "?" en la esquina abre la ayuda en cualquier momento.',
      },
    ],
  },

  reports: {
    key: 'reports-v1',
    steps: [
      {
        title: 'Constructor de reportes',
        body: 'Crea, guarda y descarga consultas en CSV. Empieza duplicando un reporte predefinido (los morados) en vez de crear uno desde cero.',
      },
      {
        selector: '[data-tour="reports-list"]',
        title: 'Reportes guardados',
        body: 'Cada renglón tiene Ejecutar (ver resultados), CSV (descarga en un clic) y Duplicar (para crear tu copia editable).',
      },
      {
        selector: '[data-tour="reports-new"]',
        title: 'Nuevo reporte',
        body: 'Crea uno desde cero con tu propia fuente, filtros y columnas. Pero para la mayoría de casos, duplicar un predefinido es más rápido.',
      },
    ],
  },

  sales: {
    key: 'sales-v1',
    steps: [
      {
        title: 'Detalle de ventas',
        body: 'Lista de tickets en el rango. Filtra por fecha, tipo (contado/crédito) y estado de pago. Haz clic en un renglón para ver el detalle + CFDI.',
      },
      {
        selector: '[data-tour="sales-presets"]',
        title: 'Atajos de fecha',
        body: 'Un clic para Hoy, Últimos 7 días, Este mes, etc. Los botones de abajo son para rangos personalizados.',
      },
      {
        selector: '[data-tour="sales-filters"]',
        title: 'Filtros y refresh',
        body: '"Limpiar filtros" regresa a la vista por defecto. "Actualizar" trae datos recién facturados sin recargar.',
      },
    ],
  },
};
